var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faPlus } from '@fortawesome/free-solid-svg-icons';
//
import useLatestQuotesWithPolicies from '../../../hooks/useLatestQuotesWithPolicies';
import useCustomerStore from '../../../stores/customerStore';
import useConfigStore from '../../../stores/configStore';
import useWidgetStore, { CurrentTabEnum } from '../../../stores/widgetStore';
import QuotePolicyItem from './Screens/Broker/QuotePolicyItem';
import StartRequest from './Screens/StartRequest';
import shade from '../../../utils/shade';
import api from '../../../api';
// import useConfigStore from '../../../stores/configStore';
var isApplicationDataAvailable = function (quotes, applicationFormData) {
    var quoteExternalRefs = quotes.map(function (quote) { return quote.externalId; });
    var applicationDataRefs = Object.keys(applicationFormData);
    var filterUnsuedApplicationData = applicationDataRefs.filter(function (v) { return !quoteExternalRefs.includes(v); });
    return (filterUnsuedApplicationData === null || filterUnsuedApplicationData === void 0 ? void 0 : filterUnsuedApplicationData.length) > 0;
};
var PolicyListing = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var onSelectPolicy = _a.onSelectPolicy, onNewPolicy = _a.onNewPolicy, brokerPolicy = _a.brokerPolicy, currentQuoteId = _a.currentQuoteId;
    var _m = useCustomerStore(), applicationFormData = _m.applicationFormData, recommendationEngine = _m.recommendationEngine, eligibilityEngine = _m.eligibilityEngine, policyAuditEngine = _m.policyAuditEngine, policyAuditAiEngine = _m.policyAuditAiEngine;
    var _o = useWidgetStore(), setCurrentTab = _o.setCurrentTab, setModalOpen = _o.setModalOpen, isEditRequested = _o.isEditRequested, setSelectedQuote = _o.setSelectedQuote, setActiveDraftQuote = _o.setActiveDraftQuote, setUnifiedState = _o.setUnifiedState;
    var latestQuotesWithPolicies = useLatestQuotesWithPolicies();
    var _p = useConfigStore(), _q = _p.style, primaryColor = _q.primaryColor, theme = _q.theme, widgetType = _p.keys.widgetType;
    var quoteStatusColorMapper = {
        'pending': 'bg-[#F3A449]',
        'referred': 'bg-[#F3A449]',
        'complete': 'bg-primary',
        'bound': 'bg-[#42D58E]',
        'rejected': 'bg-[#FD515E]',
        'MT Draft': 'bg-[#42D58E]',
        'draft': 'bg-[#b8b8b8]',
        'Generating Policy': 'bg-[#42D58E]'
    };
    var onClick = function () {
        if (policyAuditAiEngine === null || policyAuditAiEngine === void 0 ? void 0 : policyAuditAiEngine.enabled) {
            setCurrentTab(CurrentTabEnum.POLICY_AUDIT_AI_RECOMMENDED_POLICIES);
        }
        else if (recommendationEngine) {
            setCurrentTab(CurrentTabEnum.RECOMMENDED_POLICIES);
        }
        else if (eligibilityEngine) {
            setCurrentTab(CurrentTabEnum.ELIGIBILITY_ENGINE);
        }
        else
            return;
        setModalOpen(true);
        setUnifiedState({});
    };
    if (widgetType == 'broker') {
        return (React.createElement("div", { className: "flex flex-col h-full" },
            React.createElement("div", { className: "pt-1 px-6 flex justify-start" },
                React.createElement("button", { type: "button", className: "flex items-center gap-2 bg-primary text-white font-semibold text-base px-5 py-2.5 rounded-lg hover:shadow-lg transition-all", onClick: function () { return setModalOpen(true); } },
                    React.createElement(FontAwesomeIcon, { icon: faPlus, className: "text-sm" }),
                    "New Policy")),
            React.createElement("ul", { className: "flex-1" }, latestQuotesWithPolicies
                .slice()
                .sort(function (a, b) {
                return new Date(b.updatedAt).getTime() -
                    new Date(a.updatedAt).getTime();
            })
                .map(function (item) { return (React.createElement(QuotePolicyItem, { key: item.id, item: item, handleStartQuote: brokerPolicy })); }))));
    }
    var raceTracQuotes = latestQuotesWithPolicies.filter(function (q) { var _a, _b; return ((_b = (_a = q === null || q === void 0 ? void 0 : q.product) === null || _a === void 0 ? void 0 : _a.Underwriter) === null || _b === void 0 ? void 0 : _b.widgetFlow) === 'racetrac'; });
    var _r = useQuery(__spreadArray(['documents', 'multi'], ((raceTracQuotes === null || raceTracQuotes === void 0 ? void 0 : raceTracQuotes.map(function (q) { return q.id; })) || []), true), {
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var actionRequiredQuotes, allResponses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actionRequiredQuotes = {};
                        return [4 /*yield*/, Promise.all(raceTracQuotes.map(function (q) {
                                return new Promise(function (res, rej) {
                                    api.quote
                                        .getSignatureDocuments({
                                        quoteId: q.id
                                    })
                                        .then(function (response) {
                                        res({
                                            id: q.id,
                                            urls: response.data.urls
                                        });
                                    })["catch"](rej);
                                });
                            }))];
                    case 1:
                        allResponses = _a.sent();
                        allResponses.forEach(function (_a) {
                            var id = _a.id, urls = _a.urls;
                            var isActionRequired = urls &&
                                urls.length > 0 &&
                                urls.some(function (u) { return !u.key.endsWith('(signed).pdf'); });
                            if (isActionRequired) {
                                actionRequiredQuotes[id] = true;
                            }
                        });
                        return [2 /*return*/, actionRequiredQuotes];
                }
            });
        }); },
        enabled: !isEditRequested && raceTracQuotes && raceTracQuotes.length > 1,
        refetchOnWindowFocus: false
    }), actionRequiredQuotes = _r.data, isFetching = _r.isFetching;
    var shouldShowStartApplication = latestQuotesWithPolicies.length === 1 &&
        ((_d = (_c = (_b = latestQuotesWithPolicies[0]) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.Underwriter) === null || _d === void 0 ? void 0 : _d.widgetFlow) ===
            'racetrac' &&
        ((_g = (_f = (_e = latestQuotesWithPolicies[0]) === null || _e === void 0 ? void 0 : _e.items) === null || _f === void 0 ? void 0 : _f.otherParams) === null || _g === void 0 ? void 0 : _g.currQuestionGroup) ==
            null &&
        ((_h = latestQuotesWithPolicies[0]) === null || _h === void 0 ? void 0 : _h.status) === 'draft';
    if (shouldShowStartApplication) {
        var quote_1 = latestQuotesWithPolicies[0];
        return (React.createElement(StartRequest, { theme: theme, style: {
                backgroundColor: shade(primaryColor, 0.9)
            }, isButtonDisabled: false, handleClick: function () {
                onSelectPolicy(quote_1);
            }, widgetFlow: (_l = (_k = (_j = latestQuotesWithPolicies[0]) === null || _j === void 0 ? void 0 : _j.product) === null || _k === void 0 ? void 0 : _k.Underwriter) === null || _l === void 0 ? void 0 : _l.widgetFlow, buttonLabel: "Start Application", isBroker: false }));
    }
    var renderPolicyAuditListing = function () { return (React.createElement("div", { className: "flex-1 text-left" },
        React.createElement("h4", { className: "text-[#202851] text-sm font-semibold" }, "Policy Audit"),
        React.createElement("p", { className: "mt-1 text-xs text-gray-600" }, "Your audit has been submitted to the broker"))); };
    return (React.createElement("div", { className: "flex flex-col h-full" },
        React.createElement("ul", { className: "flex-1" }, latestQuotesWithPolicies.map(function (quote) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            if (currentQuoteId && quote.id !== currentQuoteId) {
                return null;
            }
            /**
             * Not showing in list if draft quote has been created for it
             * but it is not included in config
             */
            var isBrizaUnifiedHiscox = ((_b = (_a = quote === null || quote === void 0 ? void 0 : quote.product) === null || _a === void 0 ? void 0 : _a.Underwriter) === null || _b === void 0 ? void 0 : _b.widgetFlow) === 'briza_unified_hiscox';
            var ignorePolicy = (((_d = (_c = quote === null || quote === void 0 ? void 0 : quote.product) === null || _c === void 0 ? void 0 : _c.Underwriter) === null || _d === void 0 ? void 0 : _d.widgetFlow) === 'racetrac' &&
                Boolean(applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[(quote === null || quote === void 0 ? void 0 : quote.externalId) || '']) ===
                    false) ||
                (isBrizaUnifiedHiscox && !!((_e = quote === null || quote === void 0 ? void 0 : quote.partnerData) === null || _e === void 0 ? void 0 : _e.parentQuoteId));
            if (ignorePolicy) {
                return null;
            }
            var idDisplay;
            var displayText = '';
            var subText = (_f = quote.Product) === null || _f === void 0 ? void 0 : _f.productName;
            var isActionRequired = !!(actionRequiredQuotes === null || actionRequiredQuotes === void 0 ? void 0 : actionRequiredQuotes[quote.id]);
            var isPolicyAuditSubmitted = ((_h = (_g = quote === null || quote === void 0 ? void 0 : quote.product) === null || _g === void 0 ? void 0 : _g.Underwriter) === null || _h === void 0 ? void 0 : _h.widgetFlow) === 'hartford_paf' &&
                quote.status === 'pending';
            if (quote.policy &&
                ['hiscox'].includes(quote.policy.partnerIdentifier)) {
                idDisplay = (_j = quote.policy.partnerData) === null || _j === void 0 ? void 0 : _j.externalPolicyReference;
            }
            else {
                var idParts = ((_k = quote === null || quote === void 0 ? void 0 : quote.policy) === null || _k === void 0 ? void 0 : _k.id)
                    ? quote.policy.id.split('-')
                    : quote.id.split('-');
                idDisplay = "".concat(idParts[0], "-").concat(idParts[1]);
            }
            if (((_m = (_l = quote.product) === null || _l === void 0 ? void 0 : _l.Underwriter) === null || _m === void 0 ? void 0 : _m.widgetFlow) == 'racetrac') {
                var storeNumber = (_p = (_o = quote.items.requiredParams) === null || _o === void 0 ? void 0 : _o.generalInformation) === null || _p === void 0 ? void 0 : _p.storeNumber;
                subText = storeNumber
                    ? "Store # ".concat(storeNumber)
                    : quote.product.productName;
            }
            if (isBrizaUnifiedHiscox) {
                if (quote.status === 'complete') {
                    displayText = 'View Coverages/Policies';
                }
                else {
                    displayText = 'Resume Application';
                }
            }
            else if (!['complete', 'pending', 'rejected', 'draft', 'referred'].includes(quote.status)) {
                if (((_q = quote === null || quote === void 0 ? void 0 : quote.policy) === null || _q === void 0 ? void 0 : _q.insuranceStatus) == 'pending') {
                    displayText = 'Generating Policy';
                }
                else {
                    var quoteDate = new Date(quote.createdAt);
                    quoteDate.setFullYear(quoteDate.getFullYear() + 1);
                    displayText = "".concat(quoteDate.getMonth() + 1, "/").concat(quoteDate.getDate(), "/").concat(quoteDate.getFullYear());
                }
            }
            else if (quote.status === 'rejected') {
                displayText = 'Rejected';
            }
            else if (quote.status === 'referred') {
                displayText = 'Referred';
            }
            else if (isPolicyAuditSubmitted) {
                displayText = 'Submitted';
            }
            else if (quote.status == 'complete') {
                displayText = 'Ready for Purchase';
            }
            else if (quote.status == 'draft' || quote.id === currentQuoteId) {
                displayText = 'Resume Application';
            }
            else if (isActionRequired) {
                displayText = 'Action Required';
            }
            else {
                displayText = 'In Progress';
            }
            var showResumeButton = ['racetrac', 'briza_unified_hiscox'].includes(((_s = (_r = quote === null || quote === void 0 ? void 0 : quote.product) === null || _r === void 0 ? void 0 : _r.Underwriter) === null || _s === void 0 ? void 0 : _s.widgetFlow) || '') && displayText === 'Resume Application';
            return (React.createElement("li", { key: quote.id, className: "hover:bg-gray-50 active:bg-gray-200 transition-all delay-[50ms] py-2" },
                React.createElement("button", { className: "flex min-h-[84px] items-center w-full px-5", disabled: isFetching, onClick: function () {
                        setActiveDraftQuote(null);
                        onSelectPolicy(quote);
                        if (isActionRequired) {
                            setCurrentTab(CurrentTabEnum.POLICY_DOCUMENTS);
                        }
                    } },
                    React.createElement("div", { className: "flex-1 text-left" }, ((_u = (_t = quote === null || quote === void 0 ? void 0 : quote.product) === null || _t === void 0 ? void 0 : _t.Underwriter) === null || _u === void 0 ? void 0 : _u.widgetFlow) === 'racetrac' ? (React.createElement("div", null,
                        React.createElement("h4", { className: "mt-1 text-md font-bold leading-[17px]" }, subText),
                        React.createElement("div", { className: "flex gap-2" },
                            React.createElement("h4", { className: "text-[#202851] text-xs font-regular font-medium" }, quote.status == 'draft' ||
                                quote.status == 'pending' ||
                                quote.status == 'referred'
                                ? 'Application ID:'
                                : 'Policy Number:'),
                            React.createElement("h3", { className: "font-regular text-xs leading-[17px] font-medium" }, idDisplay)))) : policyAuditEngine && quote.externalId === 'PAF' ? (renderPolicyAuditListing()) : (React.createElement("div", null,
                        idDisplay ? (React.createElement(React.Fragment, null,
                            React.createElement("h4", { className: "text-[#202851] text-sm font-semibold" }, ((_w = (_v = quote === null || quote === void 0 ? void 0 : quote.product) === null || _v === void 0 ? void 0 : _v.Underwriter) === null || _w === void 0 ? void 0 : _w.widgetFlow) ===
                                'briza_unified_hiscox'
                                ? 'Application ID:'
                                : quote.status == 'draft' ||
                                    quote.status == 'pending' ||
                                    quote.status == 'referred' ||
                                    quote.status == 'rejected'
                                    ? 'Quote Number:'
                                    : 'Policy Number:'),
                            React.createElement("h3", { className: "font-bold text-lg leading-[26px]" }, idDisplay))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "h-[16px] w-[90px] rounded bg-gray-200 animate-pulse mb-[4px]" }),
                            React.createElement("div", { className: "h-[24px] w-[140px] rounded bg-gray-200 animate-pulse" }))),
                        subText && !isBrizaUnifiedHiscox && (React.createElement("h4", { className: "mt-1 text-md font-semibold leading-[17px]" }, subText))))),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        isFetching ? (React.createElement("div", { className: "flex items-center gap-2" },
                            React.createElement("div", { className: "h-4 w-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin" }))) : isActionRequired ? (React.createElement("span", { className: "inline-flex items-center gap-2 text-base font-semibold px-2.5 py-1 rounded-full border border-indigo-300 bg-indigo-50 text-indigo-800" },
                            React.createElement("span", { className: "h-2 w-2 rounded-full bg-indigo-500 animate-pulse" }),
                            "Action Required")) : (React.createElement(React.Fragment, null,
                            !showResumeButton && (React.createElement("div", { className: "h-2 w-2 ".concat(isPolicyAuditSubmitted
                                    ? 'bg-[#42D58E]'
                                    : quoteStatusColorMapper[quote.status], " rounded-full") })),
                            showResumeButton ? (React.createElement("button", { className: "rounded-2xl bg-primary flex justify-center gap-2 items-center ".concat(theme == 'night' ? 'rippleNight' : 'ripple', " text-primary font-bold mx-auto tracking-lighter px-4 py-2 w-full text-sm"), style: {
                                    backgroundColor: shade(primaryColor, 0.9)
                                } },
                                displayText,
                                React.createElement(FontAwesomeIcon, { icon: faChevronRight, size: "sm", color: primaryColor, className: "font-bold" }))) : (React.createElement("span", null, displayText)))),
                        !showResumeButton && (React.createElement(FontAwesomeIcon, { icon: faChevronRight, size: "xs", color: primaryColor }))))));
        })),
        isApplicationDataAvailable(latestQuotesWithPolicies, applicationFormData) && (React.createElement("div", { className: "pt-4 px-6" },
            React.createElement("button", { type: "button", className: "w-full border border-primary h-12 rounded-lg mx-auto", onClick: (policyAuditAiEngine === null || policyAuditAiEngine === void 0 ? void 0 : policyAuditAiEngine.enabled) ||
                    recommendationEngine ||
                    eligibilityEngine
                    ? onClick
                    : onNewPolicy },
                React.createElement("span", { className: "font-bold text-primary" }, (policyAuditAiEngine === null || policyAuditAiEngine === void 0 ? void 0 : policyAuditAiEngine.enabled) ||
                    recommendationEngine ||
                    eligibilityEngine
                    ? 'Next Recommended Policy'
                    : 'New Policy'))))));
};
export default PolicyListing;
